import { render, staticRenderFns } from "./Bookings.vue?vue&type=template&id=130070e4&scoped=true&"
import script from "./Bookings.vue?vue&type=script&lang=js&"
export * from "./Bookings.vue?vue&type=script&lang=js&"
import style0 from "./Bookings.vue?vue&type=style&index=0&id=130070e4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130070e4",
  null
  
)

export default component.exports